import { Component, OnInit } from '@angular/core';
import { ChatbotFunService } from 'src/app/services/chatbot-fun.service';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-home-footer',
  templateUrl: './home-footer.component.html',
  styleUrls: ['./home-footer.component.css']
})
export class HomeFooterComponent implements OnInit {
  currentPage:any = 'home'; 

  constructor(private homeService: HomeService , public chatbotFunService: ChatbotFunService) { }

  ngOnInit() {
    this.homeService.homeHistory$.subscribe(value => {
      this.currentPage = value;
    });
  }

  callHomePage(){
    this.homeService.setCurrentPage('home');
  }
  
  callMessageHistoryPage(){
    this.homeService.setCurrentPage('messageHistory');

  }
}
